const sports1 = [{
        title: 'Football',
        price: 'https://drive.google.com/file/d/1_VAPsWBocSshQlXbHmm1BYY_DFEVla-W/view',
        tags: '',
    },
    {
        title: 'VolleyBall',
        price: 'https://drive.google.com/file/d/1_VAPsWBocSshQlXbHmm1BYY_DFEVla-W/view',
        tags: '',
    },
    {
        title: 'BasketBall',
        price: 'https://drive.google.com/file/d/1_VAPsWBocSshQlXbHmm1BYY_DFEVla-W/view',
        tags: '',
    },
    {
        title: 'Cricket',
        price: 'https://drive.google.com/file/d/1_VAPsWBocSshQlXbHmm1BYY_DFEVla-W/view',
        tags: '',
    },
    {
        title: 'Athletics',
        price: 'https://drive.google.com/file/d/1_VAPsWBocSshQlXbHmm1BYY_DFEVla-W/view',
        tags: '',
    },
];

const sports2 = [{
        title: 'Table Tennis',
        price: 'https://drive.google.com/file/d/1_VAPsWBocSshQlXbHmm1BYY_DFEVla-W/view',
        tags: '',
    },
    {
        title: "Chess",
        price: 'https://drive.google.com/file/d/1_VAPsWBocSshQlXbHmm1BYY_DFEVla-W/view',
        tags: '',
    },
    {
        title: 'Badminton',
        price: 'https://drive.google.com/file/d/1_VAPsWBocSshQlXbHmm1BYY_DFEVla-W/view',
        tags: '',
    },
    {
        title: 'Tennis',
        price: 'https://drive.google.com/file/d/1_VAPsWBocSshQlXbHmm1BYY_DFEVla-W/view',
        tags: '',
    },
];
// eslint-disable-next-line 
export default { sports1, sports2 };
